import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {
  CalendarListParams,
  HttpResponseInterface,
  BookByHandParams,
  ISyncManual,
  IDailyPrice,
  IDeleteNote,
  ChangeStatusParams
} from '@root/router/house/house-status/http-interface';
// import {
//   MessageService,
//   Type,
//   Status,
//   NotifyModel
// } from '@root/component/message/message.service';
import { Observable } from 'rxjs/Observable';
import _ from 'lodash';

interface UpdatePriceOrStock {
  version: string;
  relation_id: number;
  type: number;
  thirdparty_list: string;
  edit_type: string;
  begin?: string;
  end?: string;
}

interface ICleanHouseList {
  begin: string;
  end: string;
  house_ids: string;
}

interface IBatchSetAvailable {
  house_ids: string;
  begin: string;
  end: string;
  available: number;
}

const CALENDAR_LIST_API = '/api/reservation_calendar/calendar_list';
const CHANGE_STATUS_API = '/api/reservation_calendar/change_status';
const SYNC_RESERVATIONS = '/api/reservation_calendar/sync_reservations';
const SYNC_CALENDAR = '/api/calendar/syncer_calendar';
const UPDATE_DAILY_PRICE_API = '/api/calendar/house_daily_price';
const BOOk_BY_HAND_API = '/api/reservation/book_by_hand';
const DELETE_NOTE_API = '/api/calendar/delete_note';
const DISABLED_DATE_LIST_API = '/api/reservation/forbidden_date_list';
const WIDGET_COUNT_API = '/api/reservation/widget';
const EXCHANGE_RATE_API = '/api/calendar/quote';
const UPDATE_PRICE_OR_STOCK_API = '/api/calendar/house_daily_price';
const CLEAN_STATUS_API = '/api/clean/house_list';
const CTRIP_COMMISSION_RATE_API = '/api/config/ctrip_commission_rate';
const BATCH_SET_AVAILABLE_API = '/api/calendar/batch_set_available';

@Injectable({
  providedIn: 'root'
})
export class HouseStatusService {
  constructor(
    // private messageService: MessageService,
    private http: HttpClient
  ) { }

  getCalendarList(
    params: CalendarListParams
  ): Observable<HttpResponseInterface> {
    const query = new HttpParams()
      .append('page', `${params.page}`)
      .append('page_size', `${params.page_size}`)
      .append('begin', `${params.begin}`)
      .append('end', `${params.end}`)
      .append('title', `${params.title}`)
      .append('thirdparty_type', `${params.thirdparty_type}`)
      .append('group_id', `${params.group_id}`)
      .append('house_id', `${params.house_id}`)
      .append('version', '1.1');

    return this.http.get(CALENDAR_LIST_API, { params: query }) as Observable<
      HttpResponseInterface
    >;
  }

  changeStatus(params: ChangeStatusParams): Observable<HttpResponseInterface> {
    /** 将boolean转成int */
    params.status = params.status ? 1 : 0;
    return this.http.post(CHANGE_STATUS_API, params) as Observable<
      HttpResponseInterface
    >;
  }

  /** 手动同步订单 */
  syncManual(params: ISyncManual) {
    return this.http.post(SYNC_RESERVATIONS, params).subscribe((res: any) => {
      if (res.error_code === 0) {
        // this.messageService.replace(
        //   Type.MANUAL_ORDER,
        //   new NotifyModel({
        //     type: Type.MANUAL_ORDER,
        //     status: Status.DOING,
        //     payload: {
        //       title: '订单房态读取中，请等待...',
        //       desc: ''
        //     }
        //   }),
        //   { position: 'center' }
        // );
      }
    });
  }

  syncCalendar(params: {
    house_id?: number;
    house_type_id?: number;
  }): Observable<HttpResponseInterface> {
    return this.http.post(SYNC_CALENDAR, params) as Observable<
      HttpResponseInterface
    >;
  }

  getWidgetCount() {
    return this.http.get(WIDGET_COUNT_API) as Observable<HttpResponseInterface>;
  }

  updateHouseDailyPrice(params: IDailyPrice) {
    return this.http.post(UPDATE_DAILY_PRICE_API, params) as Observable<
      HttpResponseInterface
    >;
  }

  batchSetAvailable (params: IBatchSetAvailable) {
    return this.http.post(BATCH_SET_AVAILABLE_API, params) as Observable<HttpResponseInterface>;
  }

  bookByHand(params: BookByHandParams) {
    return this.http.post(BOOk_BY_HAND_API, params) as Observable<
      HttpResponseInterface
    >;
  }

  deleteNote(params: IDeleteNote) {
    return this.http.post(DELETE_NOTE_API, params) as Observable<
      HttpResponseInterface
    >;
  }


  editHouseDailyPrice(params) {
    return this.http.post(UPDATE_PRICE_OR_STOCK_API, params) as Observable<HttpResponseInterface>;
  }

  getForbiddenDateList(params: { house_id: number }) {
    const query = new HttpParams().append('house_id', `${params.house_id}`);

    return this.http.get(DISABLED_DATE_LIST_API, {
      params: query
    }) as Observable<HttpResponseInterface>;
  }

  getExchangeRate(params: { from: string; to: string }) {
    const query = new HttpParams()
      .append('from', `${params.from}`)
      .append('to', `${params.to}`);

    return this.http.get(EXCHANGE_RATE_API, { params: query }) as Observable<
      HttpResponseInterface
    >;
  }

  getHouseCleanStatusList(params: ICleanHouseList) {
    const query = new HttpParams()
      .append('begin', params.begin)
      .append('end', params.end)
      .append('house_ids', params.house_ids);
    return this.http.get(CLEAN_STATUS_API, { params: query });
  }

  getCtripCommissionRate() {
    return this.http.get(CTRIP_COMMISSION_RATE_API) as Observable<HttpResponseInterface>;
  }

  updatePriceOrStock(params: UpdatePriceOrStock) {
    return this.http.post(UPDATE_DAILY_PRICE_API, params) as Observable<
      HttpResponseInterface
    >;
  }
}
